
const TO_HOME="TO_HOME";
const TO_ABOUTE_JW="TO_ABOUTE_JW";
const TO_BUSSINESS_SCOPE="TO_BUSSINESS_SCOPE";
const TO_ABOUT_POLICY="TO_ABOUT_POLICY";
const TO_FOCUS_NEWS="TO_FOCUS_NEWS";
const TO_RECRUITMENT="TO_RECRUITMENT";
const TO_TECH_FINANCE="TO_TECH_FINANCE";
const TO_CONTACT_US="TO_CONTACT_US";


const ActionType={
    TO_HOME,
    TO_ABOUTE_JW,
    TO_BUSSINESS_SCOPE,
    TO_ABOUT_POLICY,
    TO_FOCUS_NEWS,
    TO_RECRUITMENT,
    TO_TECH_FINANCE,
    TO_CONTACT_US
}

export default ActionType;